import React, { useEffect, useState } from "react";
import { Phone, MapPin, Mail, Instagram } from "lucide-react";
import { Logo } from "@/components/common/Logo";
import { api } from "@/lib/api";

export const Footer = () => {
  const [instagram, setInstagram] = useState("");

  useEffect(() => {
    api.get("/config/fees").then((r) => setInstagram(r.data?.instagram || "")).catch(() => {});
  }, []);

  const igHandle = instagram.replace(/^@/, "").trim();
  const igUrl = igHandle ? `https://instagram.com/${igHandle}` : null;

  return (
  <footer className="border-t border-sky-500/10 bg-slate-950 mt-24" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-12 grid gap-8 md:grid-cols-4">
      <div>
        <div className="flex items-center gap-2 mb-4">
          <Logo size={44} className="rounded-full" />
          <div className="flex flex-col leading-none">
            <span className="text-base font-black tracking-tight text-white">TSBRASIL</span>
            <span className="text-[10px] font-mono uppercase tracking-widest text-sky-400">Ar-Condicionado</span>
          </div>
        </div>
        <p className="text-sm text-slate-400 leading-relaxed">
          Ar-condicionado automotivo móvel. Atendimento rápido, onde seu carro estiver.
        </p>
      </div>
      <div>
        <h4 className="text-sm font-mono uppercase tracking-widest text-sky-400 mb-4">Contato</h4>
        <ul className="space-y-3 text-sm text-slate-300">
          <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-sky-400" /> <a href="https://wa.me/5581998736850" target="_blank" rel="noopener noreferrer" className="hover:text-sky-300 transition-colors" data-testid="footer-whatsapp">(81) 99873-6850</a></li>
          <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-sky-400" /> tsbrasilautoparts@gmail.com</li>
          <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-sky-400" /> Atendimento delivery</li>
        </ul>
      </div>
      <div>
        <h4 className="text-sm font-mono uppercase tracking-widest text-sky-400 mb-4">Siga-nos</h4>
        {igUrl ? (
          <a
            href={igUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-3 bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#F77737] px-4 py-2.5 rounded-lg text-white font-semibold hover:brightness-110 transition-all group"
          >
            <Instagram className="w-5 h-5" />
            <div className="flex flex-col leading-tight">
              <span className="text-[10px] font-mono uppercase tracking-widest opacity-90">Instagram</span>
              <span className="text-sm font-bold">@{igHandle}</span>
            </div>
          </a>
        ) : (
          <p className="text-sm text-slate-400">Em breve.</p>
        )}
        <p className="text-xs text-slate-500 mt-3">Acompanhe nossos trabalhos e dicas de climatização automotiva.</p>
      </div>
      <div>
        <h4 className="text-sm font-mono uppercase tracking-widest text-sky-400 mb-4">Horário</h4>
        <ul className="space-y-2 text-sm text-slate-300">
          <li>Segunda a Sexta: 08h — 12h / 14h — 18h</li>
          <li>Sábado: 08h — 12h</li>
          <li>Domingo: Fechado</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-slate-800 py-4 text-center text-xs text-slate-500 font-mono">
      © {new Date().getFullYear()} TSBRASIL Ar-Condicionado — Todos os direitos reservados
    </div>
  </footer>
  );
};
